<p *ngIf="hasMessage">{{ message | async }}</p>
